const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const MOIS = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

export function isoDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
}

/** Next Sunday (today if today is Sunday). */
export function nextSunday(from = new Date()): string {
  const d = new Date(from);
  d.setHours(12, 0, 0, 0);
  const delta = (7 - d.getDay()) % 7;
  d.setDate(d.getDate() + delta);
  return isoDate(d);
}

/** "2026-06-21" -> "Dimanche 21 juin 2026" */
export function formatFrLong(iso: string): string {
  const [y, m, day] = iso.split("-").map(Number);
  const d = new Date(y, m - 1, day, 12);
  const jour = JOURS[d.getDay()];
  return `${jour.charAt(0).toUpperCase()}${jour.slice(1)} ${day} ${MOIS[m - 1]} ${y}`;
}
